import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mutationError: null,
  mutationSuccess: null,
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    clearMutationError: (state) => {
      state.mutationError = null;
    },
    clearMutationSuccess: (state) => {
      state.mutationSuccess = null;
    },
  },
});

export const { clearMutationError, clearMutationSuccess } = customerSlice.actions;
export default customerSlice.reducer;